import axios from 'axios';

const API = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:6555');
const client = axios.create({ baseURL: `${API}/api/admin/content-plan`, timeout: 30000 });
client.interceptors.request.use(config => {
  const token = localStorage.getItem('admin_token') || localStorage.getItem('portal_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
client.interceptors.response.use(response => response, error => {
  if (error.response?.status === 401) {
    localStorage.removeItem('admin_token');
  localStorage.removeItem('portal_token');
    window.location.replace('/admin/login');
  }
  return Promise.reject(error);
});

export function contentPlanError(error) {
  const detail = error?.response?.data?.detail;
  if (Array.isArray(detail)) return detail.map(item => item.msg).join('. ');
  return (typeof detail === 'string' && detail) || 'Не удалось сохранить изменения. Попробуйте ещё раз.';
}
export const listContentItems = params => client.get('/items', { params }).then(r => r.data);
export const getContentItem = id => client.get(`/items/${id}`).then(r => r.data);
export const createContentItem = data => client.post('/items', data).then(r => r.data);
export const updateContentItem = (id, data) => client.patch(`/items/${id}`, data).then(r => r.data);
export const archiveContentItem = id => client.delete(`/items/${id}`).then(r => r.data);
export const restoreContentItem = id => client.post(`/items/${id}/restore`).then(r => r.data);
export const duplicateContentItem = id => client.post(`/items/${id}/duplicate`).then(r => r.data);
export const deleteContentAttachment = id => client.delete(`/attachments/${id}`).then(r => r.data);
export const uploadContentAttachment = (id, file, onProgress) => {
  const form = new FormData();
  form.append('file', file);
  return client.post(`/items/${id}/attachments`, form, {
    timeout: 15 * 60 * 1000,
    onUploadProgress: event => onProgress?.(event.total ? Math.round(event.loaded / event.total * 100) : 0),
  }).then(r => r.data);
};
const previews = new Map();
export async function contentPreviewUrl(id, refresh = false) {
  const cached = previews.get(id);
  if (!refresh && cached?.until > Date.now()) return cached.url;
  const data = await client.get(`/attachments/${id}/preview-url`).then(r => r.data);
  const url = data.url.startsWith('/') ? `${API}${data.url}` : data.url;
  previews.set(id, { url, until: Date.now() + 10 * 60 * 1000 });
  return url;
}
